<template>
  <Card>
    <div class="flex flex-col p-16">
      <EmailConfirmedIllustration class="mx-auto" />
      <h1 class="text-h2 mt-24 md:mt-32">Your review is posted</h1>
      <p class="text-body mt-16">
        Thanks for validating your email and keeping our users safe. Your review has been posted to the sitter's profile.
      </p>
      <Button
        value="Signup for sittercity"
        variant="primary"
        size="medium"
        class="mt-24 mx-auto w-full md:mt-32 md:w-auto"
        href="/registration?member_type=seeker"
      />
    </div>
  </Card>
</template>

<script lang="ts">
import EmailConfirmedIllustration from '@/graphics/illustrations/EmailConfirmedIllustration.vue';
import Card from '@/components/card/Card.vue';
import Button from '@/components/button/Button.vue';

export default {
  name: 'VerificationSuccess',
  components: { EmailConfirmedIllustration, Card, Button },
};
</script>
